import React, { useEffect, useRef, useState } from "react";
import { getEmailSuggestion } from "../utils/emailSuggestion";
import EmailSuggestion from "./EmailSuggestion";

const Slide6 = ({ initialData = {}, onNext, onBack }) => {
  const [formData, setFormData] = useState({
    personFirstName: "",
    personLastName: "",
    personEmail: "",
    ...initialData,
  });
  const [isFormValid, setIsFormValid] = useState(false);
  const [errors, setErrors] = useState({});
  const [showErrors, setShowErrors] = useState(false);
  const [emailSuggestion, setEmailSuggestion] = useState(null);
  const emailInputRef = useRef(null);
  // First Next press on a likely email typo holds the funnel and surfaces the
  // "Did you mean" suggestion instead of advancing. Accepting the suggestion
  // or pressing Next again proceeds.
  const typoAckRef = useRef(false);

  useEffect(() => {
    const { personEmail } =
      formData;
    const isEmailValid =
      !personEmail || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personEmail);

    setIsFormValid(
      // personFirstName &&
      //   personLastName &&
        personEmail &&
        // personPhone &&
        // isFirstNameValid &&
        // isLastNameValid &&
        isEmailValid 
        // &&
        // isPhoneValid
    );

    setErrors({
      // personFirstName:
      //   personFirstName && !isFirstNameValid ? "Invalid first name format" : "",
      // personLastName:
      //   personLastName && !isLastNameValid ? "Invalid last name format" : "",
      personEmail: personEmail && !isEmailValid ? "Please enter a valid email address" : "",
      // phone: phone && !isPhoneValid ? "Invalid phone format" : "",
    });
  }, [formData]);

  const handleButtonClick = (e) => {
    const { personEmail } = formData;
    const isEmailValid = personEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personEmail);

    const newErrors = {};
    if (!personEmail) {
      newErrors.personEmail = "Please enter your email address";
    } else if (!isEmailValid) {
      newErrors.personEmail = "Please enter a valid email address";
    }

    if (Object.keys(newErrors).length > 0) {
      e.preventDefault();
      setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
      setShowErrors(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (showErrors) setShowErrors(false);
    if (name === "personEmail") { setEmailSuggestion(null); typoAckRef.current = false; }
  };

  const handleEmailBlur = (e) => {
    setEmailSuggestion(getEmailSuggestion(e.target.value));
  };

  const acceptEmailSuggestion = (suggestion) => {
    setFormData((prev) => ({ ...prev, personEmail: suggestion }));
    setEmailSuggestion(null);
    typoAckRef.current = false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailTypoSuggestion = getEmailSuggestion(formData.personEmail);
    if (emailTypoSuggestion && !typoAckRef.current) {
      setEmailSuggestion(emailTypoSuggestion);
      typoAckRef.current = true;
      return;
    }
    if (isFormValid) {
      window.scrollTo(0, 0);
      onNext("thankYou", formData);
    } else {
      const firstInvalidField = Object.keys(errors).find((key) => errors[key]);
      if (firstInvalidField) {
        document.getElementById(firstInvalidField).focus();
      }
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div className="step-section">
          <h1>We'll need to see your pool in person</h1>
          <div className="subtitle">
            <span>
              We'll reach out to schedule a time to come by, conduct some
              <div className="text-br p-0" />
              tests, and help get you back to clear in no time!
            </span>
          </div>
        </div>
        <div className="field-mini-wrap">
          {/* <div className="row">
            <div className="col-md-6">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input ${
                    errors.personFirstName ? "invalid-field" : ""
                  }`}
                  placeholder="First name"
                  name="personFirstName"
                  id="personFirstName"
                  value={formData.personFirstName}
                  ref={firstNameInputRef}
                  onChange={handleInputChange}
                  aria-invalid={!!errors.personFirstName}
                  pattern="[a-zA-Z\s'-]{2,}"
                  title="First name should be at least 2 characters long and contain only letters, spaces, apostrophes, or hyphens."
                  required
                />
                <label htmlFor="personFirstName">First name</label>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input ${
                    errors.personLastName ? "invalid-field" : ""
                  }`}
                  placeholder="Last name"
                  name="personLastName"
                  id="personLastName"
                  value={formData.personLastName}
                  ref={lastNameInputRef}
                  onChange={handleInputChange}
                  aria-invalid={!!errors.personLastName}
                  pattern="[a-zA-Z\s'-]{2,}"
                  title="Last name should be at least 2 characters long and contain only letters, spaces, apostrophes, or hyphens."
                  required
                />
                <label htmlFor="personLastName">Last name</label>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-md-12">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input ${
                    showErrors && errors.personEmail ? "invalid-field" : ""
                  }`}
                  placeholder="Enter an email"
                  name="personEmail"
                  id="personEmail"
                  type="email"
                  value={formData.personEmail}
                  ref={emailInputRef}
                  onChange={handleInputChange}
                  onBlur={handleEmailBlur}
                  aria-invalid={showErrors && !!errors.personEmail}
                  pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
                  title="Email should be in the format: example@example.com."
                  required
                />
                <label htmlFor="personEmail">Email</label>
              </div>
              {showErrors && errors.personEmail && (
                <div className="field-error-message">{errors.personEmail}</div>
              )}
              <EmailSuggestion
                suggestion={emailSuggestion}
                onAccept={acceptEmailSuggestion}
              />
            </div>
            {/* <div className="col-md-6">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input ${
                    errors.phone ? "invalid-field" : ""
                  }`}
                  placeholder="Phone"
                  name="phone"
                  id="phone"
                  type="text"
                  value={formData.phone}
                  ref={phoneInputRef}
                  onChange={handleInputChange}
                  aria-invalid={!!errors.phone}
                  required
                />
                <label htmlFor="phone">Phone</label>
              </div>
            </div> */}
          </div>
        </div>
        <button type="submit" className={`btn btn-next ${
            !isFormValid
              ? "button-disabled"
              : ""
          }`} onClick={handleButtonClick} >
          Next
        </button>
        <input type="hidden" id="progress_slide_1" data-width="75%"/>
      </form>
    </div>
  );
};

export default Slide6;
